import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../imageService';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import MenuScreen from '../components/mpmb/menu-screen';
import BrandLineScreen from '../common/brand-line-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import AuthorityScreen from '../common/authority-screen';
import ReviewFlowScreen from '../common/review-flow-screen';
import FinalScreen from '../components/lm-d-s/final-screen';
import WelcomePredictionScreen from '../components/mpmb/welcome-prediction-screen';
import CompanyInfoScreen from '../components/mpmb/company-info-screen';
import FaqScreen from '../components/mpmb/faq-screen';
import CookieManagementScreen from '../components/mpmb/cookie-management-screen';
import PredictionScreen from '../components/mpmb/prediction-screen';
import WelcomeAgeVerify from '../components/mpmb/welcome-age-verify';
import FaceCaptureScreen from '../components/ua-brand/face-capture-screen';
import UAHostess from './UA-Hostess';
import useScreenHistory from '../hooks/useScreenHistory';

const partners = {
  cig: '',
  rozetka: ''
};

const MPMB = () => {
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 8,
      initialState: { brandLine: '' }
    });
  const brandLine = historyState.brandLine || '';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init('25UA-MPM-B');
    sendEvent('age_verification_without');
    sessionStorage.setItem('utm_source', 'PRODUCT');
    sessionStorage.setItem('utm_source_id', '25UA-MPM-B');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <MenuScreen
            partners={partners}
            setScreenNumber={setScreenNumber}
            title="Philip Morris blue"
            backgroundImage={`url("${getImageFromS3('images/mpmb/bg.png')}")`}
          />
        );
      }
      case 2: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(3, true)}
            nextButtonClick={() => setScreenNumber(5)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 3: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => {
              setScreenNumber(2, false, { brandLine: brand });
            }}
            handleBackButton={() => setScreenNumber(1, true)}
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 4: {
        return (
          <AuthorityScreen
            partners={partners}
            setScreenNumber={cb}
            setReviewScreenNumber={() => setScreenNumber(5)}
          />
        );
      }
      case 5: {
        return (
          <FinalScreen
            setScreenNumber={cb}
            withReviewButton
            setScreenNumberToReview={() => setScreenNumber(7)}
          />
        );
      }
      case 6: {
        return <FinalScreen setScreenNumber={cb} />;
      }
      case 7: {
        return (
          <ReviewFlowScreen
            setScreenNumber={cb}
            setSubmitReviewScreenNumber={() => setScreenNumber(11)}
            innerScreenNumber={historyState.innerScreenNumber}
            setInnerScreenNumber={(val) =>
              setScreenNumber(7, false, { innerScreenNumber: val })
            }
          />
        );
      }
      case 8: {
        return <WelcomePredictionScreen setScreenNumber={setScreenNumber} />;
      }
      case 9: {
        return (
          <CompanyInfoScreen
            handleBackButtonClick={() => setScreenNumber(8, true)}
            setScreenNumber={setScreenNumber}
          />
        );
      }
      case 10: {
        return (
          <FaqScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(8, true)}
          />
        );
      }
      case 11: {
        return <CookieManagementScreen setScreenNumber={setScreenNumber} />;
      }
      case 12: {
        return (
          <PredictionScreen
            setScreenNumber={setScreenNumber}
            handleBackButton={() => setScreenNumber(1, true)}
          />
        );
      }
      case 13: {
        return <WelcomeAgeVerify setScreenNumber={setScreenNumber} />;
      }
      case 14: {
        return <FaceCaptureScreen setScreenNumber={setScreenNumber} />;
      }
      case 15: {
        return (
          <UAHostess
            isNewProductFlow
            handleBackToMenu={() => setScreenNumber(1, true)}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };
  return (
    <div className={styles.pageContainer} id="mpmb-screen-container">
      <div className={styles.contentContainer}>
        <ScreensContext.Provider
          value={{
            endSessionType,
            setEndSessionType,
            isDisplayedAll,
            setIsDisplayedAll
          }}
        >
          {getScreen(screenNumber, setScreenNumber)}
        </ScreensContext.Provider>
      </div>
    </div>
  );
};

export default MPMB;
